__webpack_require__.p = "/REACT-ERC20-staking/";